import Icon from '../components/Icon.vue'

Icon.register({"gem":{"width":576,"height":512,"paths":[{"d":"M485.5 0L576 160H474.9L405.7 0H485.5zM357.5 0L426.7 160H149.3L218.5 0H357.5zM90.5 0H170.3L101.1 160H0L90.5 0zM0 192H100.7L223.7 443.7C225.2 446.8 221 449.6 218.7 447L0 192zM148.2 192H427.8L290.8 510.2C289.8 512.6 286.3 512.6 285.3 510.2L148.2 192zM352.3 443.7L475.3 192H576L357.3 446.9C355 449.6 350.8 446.8 352.3 443.7z"}]}})



// WEBPACK FOOTER //
// ./node_modules/vue-awesome/icons/gem.js